import { Grid } from '@mui/material';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { RenderInputByTypeMobile } from '../../../components/formGroupGenerator/RenderInputByTypeMobile';

export const DocumentosSAPFilters = ({
    filters,
    handleSearch,
    handleChangeFilters,
    disableFilters,
    estados
}) => {

    return (
        <Grid
            container
            spacing={2}
            sx={{ marginBottom: '25px' }}
        >
            <Grid size={{ xs: 12, md: 2.5, xl: 2.5 }}>
                <RenderInputByTypeMobile
                    input={{
                        type: 'select',
                        displayName: 'Estado',
                        name: 'idEstado',
                        key: `${filters?.idEstado}-idEstado`,
                        options: estados,
                        disabled: disableFilters
                    }}
                    value={filters.idEstado}
                    handleChange={handleChangeFilters}
                />
            </Grid>
            <Grid size={{ xs: 12, md: 2.5, xl: 2.5 }}>
                <RenderInputByTypeMobile
                    input={{
                        type: 'date',
                        displayName: 'Fecha desde',
                        name: 'fechaDesde',
                        key: `${filters?.fechaDesde}-fechaDesde`,
                        disabled: disableFilters
                    }}
                    value={filters.fechaDesde}
                    handleChange={handleChangeFilters}
                />
            </Grid>
            <Grid size={{ xs: 12, md: 2.5, xl: 2.5 }}>
                <RenderInputByTypeMobile
                    input={{
                        type: 'date',
                        displayName: 'Fecha hasta',
                        name: 'fechaHasta',
                        key: `${filters?.fechaHasta}-fechaHasta`,
                        disabled: disableFilters
                    }}
                    value={filters.fechaHasta}
                    handleChange={handleChangeFilters}
                />
            </Grid>
            <Grid size={{ xs: 12, md: 2.5, xl: 2.5 }}>
                <RenderInputByTypeMobile
                    input={{
                        type: 'string',
                        displayName: 'N° documento',
                        name: 'numeroDoc',
                        disabled: disableFilters
                    }}
                    value={filters.numeroDoc}
                    handleChange={handleChangeFilters}
                />
            </Grid>
            <Grid sx={{ textAlign: 'right' }} size={{ xs: 12, sm: 6, md: 2, xl: 2 }}>
                <CustomButton
                    variant='contained'
                    onClick={() => handleSearch()}
                    size='small'
                    disabled={disableFilters}
                >
                    Buscar
                </CustomButton>
            </Grid>
        </Grid>
    )
}